import { useState } from "react";

import { Roles } from "@doitintl/cmp-models";

import ShareDialog from "../dialogs/shareDialog/ShareDialog";
import { CloudAnalyticsEntities } from "../utilities";
import { type AttributionDataWithId } from "./AllocationBrowser/AllocationBrowser";
import { useShareAllocationHandler } from "./hooks";

export type Props = {
  open: boolean;
  attributions: AttributionDataWithId[];
  showPresetExcludedAlert?: boolean;
  onClose: () => void;
};

export function AllocationShareDialog({ open, attributions, showPresetExcludedAlert, onClose }: Props) {
  const [shareLoading, setShareLoading] = useState(false);
  const handleChangeSharing = useShareAllocationHandler(attributions, onClose, setShareLoading);
  return (
    <ShareDialog
      open={open}
      onClose={onClose}
      entity={CloudAnalyticsEntities.ATTRIBUTION}
      loading={shareLoading}
      availableRoles={[Roles.EDITOR, Roles.VIEWER]}
      defaultRole={Roles.EDITOR}
      shareEntities={attributions}
      showPresetExcludedAlert={showPresetExcludedAlert}
      onSharingChanged={handleChangeSharing}
    />
  );
}
